
export const isSpecialKey = (e) => e.ctrlKey || e.altKey || e.metaKey;
